'use strict';

/**
 * Replace the URL query string color during color selection update in PDP.
 * @param {string} needle parameter to detect the key, e.g. "_COL_", "_COLORI_", etc.
 * @param {string} color new color to be submitted
 */
const updateProductDetailUrl = (needle, color) => {
    // Build url object
    var urlObject = new URL(window.location.href);
    var queryString = urlObject.searchParams;

    // Retrieve exact key name to be replaced
    var qsKeyToUpdate;
    for (var qsKey of queryString.keys()) {
        var qsValue = queryString.get(qsKey);
        if (qsKey.toLowerCase().indexOf(needle) !== -1 && qsValue) {
            qsKeyToUpdate = qsKey;
            break;
        }
    }

    // Cancel action if key is not found
    if (!qsKeyToUpdate) {
        return;
    }

    // Push new value to querystring key obtained above
    urlObject.searchParams.set(qsKeyToUpdate, color);
    // Replace current URL with new
    window.history.replaceState(null, document.title, urlObject.href);
};

export {
    updateProductDetailUrl
};
